module.exports = __webpack_public_path__ + "static/media/mindy_thumbsup_patient.d5885270.png";